import { safeSessionStorage } from './safeStorage';

export const GOOGLE_VERIFIER_KEY = 'mp_google_verifier';
export const GOOGLE_HANDOFF_KEY = 'mp_google_handoff';
const MAX_AGE_MS = 5 * 60 * 1000;
const validTicket = value => typeof value === 'string' && /^[A-Za-z0-9_-]{20,200}$/.test(value);
const validVerifier = value => typeof value === 'string' && /^[A-Za-z0-9_-]{43,128}$/.test(value);

export function clearGoogleHandoff() {
  safeSessionStorage.removeItem(GOOGLE_HANDOFF_KEY);
  safeSessionStorage.removeItem(GOOGLE_VERIFIER_KEY);
}

export function readGoogleHandoff(hash = window.location.hash, now = Date.now()) {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const verifier = safeSessionStorage.getItem(GOOGLE_VERIFIER_KEY);
  if (params.has('error')) {
    clearGoogleHandoff();
    return { error: params.get('error') || 'invalid_state' };
  }
  if (params.has('ticket')) {
    const ticket = params.get('ticket');
    if (!validTicket(ticket) || !validVerifier(verifier)) {
      clearGoogleHandoff();
      return { error: 'invalid_state' };
    }
    const value = { ticket, verifier, expiresAt: now + MAX_AGE_MS };
    // This is only reload recovery. The server still enforces binding, expiry and single use.
    // No password, access token or refresh token is stored in this record.
    safeSessionStorage.setItem(GOOGLE_HANDOFF_KEY, JSON.stringify(value));
    return value;
  }
  try {
    const value = JSON.parse(safeSessionStorage.getItem(GOOGLE_HANDOFF_KEY) || 'null');
    if (value && validTicket(value.ticket) && validVerifier(value.verifier) && value.verifier === verifier &&
        Number.isFinite(value.expiresAt) && value.expiresAt > now && value.expiresAt <= now + MAX_AGE_MS) return value;
  } catch (_) { /* Invalid or unavailable tab storage must not bypass a new Google sign-in. */ }
  clearGoogleHandoff();
  return { error: 'invalid_state' };
}
